<template>
  <div class="schedule-page">
    <header class="header-title flex-middle-only">
      <img
        style="height: 36px; margin-right: 10px"
        src="./img/menu.png"
        alt=""
      />
      <span style="font-size: 26px">全部分类</span>

      <ul class="flex-middle-only" style="margin-left: 16px">
        <li
          class="sport-category flex-middle"
          :class="{ active: sportId === 999 }"
          @click="selectSportCategory(999)"
        >
          焦点
        </li>
        <li
          class="sport-category flex-middle"
          :class="{ active: sportId === 1 }"
          @click="selectSportCategory(1)"
        >
          足球
        </li>
        <li
          class="sport-category flex-middle"
          :class="{ active: sportId === 2 }"
          @click="selectSportCategory(2)"
        >
          篮球
        </li>
      </ul>
    </header>
    <div class="right-panel">
      <div class="match-title">
        <div v-show="sportId != 999">
          <div
            class="match-title-tab flex-middle"
            :class="{ active: category === 777 }"
            @click="selectMatchCategory(777)"
          >
            热门
          </div>
        </div>
        <div
          class="match-title-tab flex-middle"
          :class="{ active: category === 0 }"
          @click="selectMatchCategory(0)"
        >
          即时
        </div>
        <div
          class="match-title-tab flex-middle"
          :class="{ active: category === 666 }"
          @click="selectMatchCategory(666)"
        >
          赛程
        </div>
        <div
          class="match-title-tab flex-middle"
          :class="{ active: category === 3 }"
          @click="selectMatchCategory(3)"
        >
          赛果
        </div>
        <div
          class="match-title-tab flex-middle"
          :class="{ active: category === 999 }"
          @click="selectMatchCategory(999)"
        >
          <span class="favorite-badge" v-if="favoriteMatches > 0">{{
            favoriteMatches > 99 ? "99+" : favoriteMatches
          }}</span
          >收藏
        </div>

        <el-popover
          placement="bottom-end"
          popper-class="popper-top-bg"
          width="560"
          trigger="click"
          :visible-arrow="false"
          v-model="showPopover"
          v-if="category !== 999"
        >
          <el-button
            slot="reference"
            class="match-btn"
            :class="{ active: showPopover }"
          >
            赛事
            <i class="el-icon-caret-bottom el-icon--right"></i>
          </el-button>

          <div class="match-popover">
            <div class="match-popover-content">
              <div v-for="cate of leagues" :key="cate.first_letter">
                <h3 class="title">{{ cate.first_letter }}</h3>
                <el-row :gutter="14" style="margin-bottom: 24px">
                  <el-col
                    :span="8"
                    style="margin-top: 10px"
                    v-for="league of cate.comps"
                    :key="league.comp"
                  >
                    <div
                      class="grid-content col-league flex-middle-only"
                      :style="{
                        background: !!selectedLeagues[league.comp]
                          ? _getCateColorStyle(cate.first_letter).activeBgColor
                          : '#F9F9FB',
                      }"
                      @click.stop="handleSelectLeague(league)"
                    >
                      <i
                        class="check-league flex-middle"
                        :class="{
                          'el-icon-check': !!selectedLeagues[league.comp],
                        }"
                        :style="{
                          borderColor: !!selectedLeagues[league.comp]
                            ? _getCateColorStyle(cate.first_letter).activeColor
                            : '#cfcfcf',
                          background: !!selectedLeagues[league.comp]
                            ? _getCateColorStyle(cate.first_letter).activeColor
                            : 'none',
                        }"
                      />
                      <div
                        class="flex-1 flex-between"
                        :style="{
                          color: !!selectedLeagues[league.comp]
                            ? _getCateColorStyle(cate.first_letter).activeColor
                            : '#999',
                        }"
                      >
                        <span>{{ league.comp_short_zh }}</span>
                        <span>{{ league.quantity }}</span>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>

            <footer
              class="match-popover-footer flex-end flex-middle-only"
              @click.stop
            >
              <div class="flex-1" style="color: #999">
                选中
                <span style="color: #02a8a2">{{ selectedLeagueMatches }}/</span
                >{{ allLeagueMatches }}场
              </div>
              <el-button
                class="popover-footer-btn flex-middle"
                style="color: #02a8a2"
                @click="handleSelectAllLeague(1)"
                >全选</el-button
              >
              <el-button
                class="popover-footer-btn flex-middle"
                style="color: #999; margin: 0 0.16rem"
                @click="handleSelectAllLeague(-1)"
                >反选</el-button
              >
              <el-button
                class="popover-footer-btn flex-middle confirm-btn"
                style="color: #fff"
                @click="getMatch"
                :loading="loading"
                >确定</el-button
              >
            </footer>
          </div>
        </el-popover>
      </div>
      <div class="match-swiper" v-if="Object.keys(filterDates).length > 0">
        <div class="match-swiper-line"></div>
        <div class="swiper-match-date flex-middle-only">
          <div
            class="swiper-slide"
            :id="`date-${key}`"
            v-for="(item, key) in filterDates"
            :key="key"
          >
            <div
              class="date-item re"
              :class="{ select: selectedDate.ymd === item.ymd }"
              @click="changeDate(item)"
            >
              <div class="ab-middle-x up-line"></div>
              <div class="select-date-icon"></div>
              <div class="date-item-t">
                {{
                  item.ymd === yestoday
                    ? "昨天"
                    : item.ymd === today
                    ? "今天"
                    : item.ymd === tomorroy
                    ? "明天"
                    : item.week
                }}
              </div>
              <div class="date-item-b">
                <div>{{ item.md }} {{ dateOfCounts[item.ymd] || "0" }}场</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="live-match">
        <div class="match-nav">
          <div>{{ selectedDate.md }}</div>
          <div>{{ selectedDate.week2 }}</div>
          <div style="display: flex">
            <div
              class="match-nav-btn"
              :class="{ active: isLive === 0 }"
              @click="selectLiveType(0)"
            >
              全部
            </div>
            <div
              class="match-nav-btn"
              :class="{ active: isLive === 1 }"
              @click="selectLiveType(1)"
            >
              直播中
            </div>
          </div>
        </div>
        <div class="no-data" v-show="matches.length === 0 && loaded">
          <img src="./img/no_data.png" alt="" />
        </div>

        <div class="match-list-box" v-loading="loading">
          <MatchRecommendST
            @refresh="getMatch"
            @favorite-match="changeFavoriteMatches"
            :pendingMatch="matches"
          >
          </MatchRecommendST>
        </div>

        <div v-show="matches.length > 0" class="match-page">
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="10"
            :total="totalCount"
            @current-change="handleCurrentChange"
            :current-page="page"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!--自定义toast-->
    <div class="toast_message" v-show="showToast">{{ toastMessage }}</div>
  </div>
</template>

<script>
import MatchRecommendST from "@/components/match-recommend/match-recommend-st";
import { post } from "@/util/http";
import { dayCount } from "@/util/time";
import { mapMutations } from "vuex";

export default {
  // metaInfo() {
  //   return {
  //     title: "Xôi Lạc TV - Trực Tiếp Bóng Đá Hôm Nay | Xem Bóng Đá Miễn Phí",
  //     meta: [
  //       {
  //         name: "keywords",
  //         content:
  //           "xoilac, xoilac tv, xôi lạc trực tiếp bóng đá hôm nay, truc tiep bong da, xem bong da truc tuyen",
  //       },
  //     ],
  //   };
  // },
  components: {
    MatchRecommendST,
  },
  data() {
    const { s = 999, d = 0, c = 777, i = 0, l = "" } = this.$route.query;

    const selectedDate = dayCount(Number(d));

    const selectedLeagues = {};

    l?.split(",").forEach((league_name) => {
      selectedLeagues[league_name] = {
        comp: league_name,
      };
    });

    return {
      sportId: Number(s),
      selectedDate,
      category: Number(s) === 999 ? 0 : Number(c),
      leagues: [],
      selectedLeagues: selectedLeagues,
      loading: true,
      loaded: false,
      isLive: Number(i),
      competition_id: 0,
      page: 1,
      totalCount: 0,
      isFlag: 1,
      matches: [],
      showPopover: false,
      favoriteMatches: 0,
      dateOfCounts: {},
      //toast是否显示
      showToast: false,
      //toast中的消息内容
      toastMessage: "",
      timerToast: null,
    };
  },

  computed: {
    selectedLeagueMatches() {
      return Object.values(this.selectedLeagues).length;
    },

    allLeagueMatches() {
      let total = 0;
      this.leagues.forEach((cate) => {
        total += cate.comps.length;
      });
      return total;
    },

    filterDates() {
      let filterDates = {};

      let range = [-7, 7];
      // 比赛状态, 0-所有(默认), 1-仅进行中的赛事,3-仅完场的赛事(赛果),赛程 666, 热门 777,赛事搜索888, 收藏999
      switch (this.category) {
        case 0:
          range = [];
          break;
        case 3:
          range = [-6, 0];
          break;
        case 666:
          range = [0, 6];
          break;
        case 999:
          range = [];
          break;
        default:
          range = [-7, 7];
      }
      if (range.length === 0) return {};

      for (let i = range[0]; i <= range[1]; i++) {
        const dateInfo = dayCount(i);

        filterDates[dateInfo.ymd] = {
          ...dateInfo,
        };
      }
      console.log(filterDates);

      return {
        ...filterDates,
      };
    },

    disabledArrowBtn() {
      const arr = Object.values(this.filterDates) || [];
      const first = arr[0] || {};
      const last = arr[arr.length - 1] || {};
      if (this.selectedDate.ymd === first.ymd) {
        return {
          prev: true,
          next: false,
        };
      } else if (this.selectedDate.ymd === last.ymd) {
        return {
          prev: false,
          next: true,
        };
      }
      return {
        prev: false,
        next: false,
      };
    },
  },

  methods: {
    ...mapMutations(["toggleLogin"]),

    // 切换 焦点/足球/篮球
    selectSportCategory(sportId) {
      this.sportId = sportId;

      if (sportId === 999) {
        this.category = 0;
      }
      // 重置 直播中的赛事 为全部
      this.isLive = 0;

      this.page = 1;

      this.scrollToDateItem(dayCount(0), "auto");

      // 重置选中的联赛
      this.selectedLeagues = {};

      // 刷新联赛列表
      this.getLeagues();

      // 搜索列表
      this.getMatch();

      // 获取收藏比赛
      this.getUserFavoriteMatches();
    },

    // 切换 热门/即时/赛程/赛果/收藏
    selectMatchCategory(category) {
      const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
      if (category === 999 && !userInfo.id) {
        this.toggleLogin();
        return;
      }

      this.category = category;

      // 重置 直播中的赛事 为全部
      this.isLive = 0;

      this.page = 1;

      // 重置选中的联赛
      this.selectedLeagues = {};

      this.scrollToDateItem(dayCount(0), "auto");

      this.getLeagues();

      // 搜索列表
      this.getMatch();
    },

    // 切换 全部/直播中
    selectLiveType(type = 1) {
      this.isLive = type;

      this.page = 1;

      this.scrollToDateItem(dayCount(0), "auto");

      // 重置选中的联赛
      this.selectedLeagues = {};

      // 刷新联赛列表
      this.getLeagues();

      // 搜索列表
      this.getMatch();
    },

    // 切换日期
    changeDate(item = {}) {
      this.page = 1;
      this.isLive = 0;

      // 重置选中的联赛
      this.selectedLeagues = {};

      this.scrollToDateItem(item);

      // 刷新联赛列表
      this.getLeagues();

      this.getMatch();
    },

    // 滚动到指定的 日期
    scrollToDateItem(flag = "next", behavior = "smooth") {
      // 当前位置
      let current = this.selectedDate.addDayCount;
      const dates = Object.values(this.filterDates);
      if (flag === "next") {
        current = Math.min(current + 1, dates[dates.length - 1].addDayCount);
      } else if (flag === "prev") {
        current = Math.max(current - 1, dates[0].addDayCount);
      } else {
        current = flag.addDayCount;
      }

      this.selectedDate = dayCount(current);

      setTimeout(() => {
        const scrollToEle = document.getElementById(
          `date-${this.selectedDate.ymd}`
        );
        scrollToEle?.scrollIntoView({
          behavior,
          block: "center",
          inline: "start",
        });
      }, 50);
    },

    // 选择页数
    handleCurrentChange(val) {
      this.page = val;
      this.getMatch();
    },

    // 根据联赛 搜索比赛列表
    handleSelectLeague(league = {}) {
      if (this.selectedLeagues[league.comp]) {
        delete this.selectedLeagues[league.comp];
      } else {
        this.selectedLeagues[league.comp] = league;
      }
      this.selectedLeagues = {
        ...this.selectedLeagues,
      };
    },

    // 选取全部联赛 1 全选 2 反选
    handleSelectAllLeague(flag) {
      const obj = {};

      this.leagues.forEach((cate) => {
        cate.comps.forEach((league) => {
          // 全选
          if (flag === 1) {
            obj[league.comp] = league;
          }

          // 反选
          if (flag === -1) {
            if (!this.selectedLeagues[league.comp]) obj[league.comp] = league;
          }
        });
      });

      this.selectedLeagues = obj;
    },

    changeFavoriteMatches(flag) {
      console.log("changeFavoriteMatches===", flag);
      this.favoriteMatches += flag;
    },

    _getCateColorStyle(first_letter = "A") {
      return this.league_colors[first_letter] || {};
    },

    resetUrlSearchQuery() {
      const origin = window.location.origin;
      const path = window.location.pathname;
      const league_names = Object.keys(this.selectedLeagues).join(",");
      const url = `${origin}${path}?s=${this.sportId}&c=${this.category}&l=${league_names}&d=${this.selectedDate.addDayCount}&i=${this.isLive}`;

      window.history.pushState("", "", url);
    },

    // 页面初始化
    initialPage() {
      console.log("this.selectedLeagues", this.selectedLeagues);

      this.getLeagues();
      this.getMatch();
      this.getUserFavoriteMatches();

      setTimeout(() => {
        this.scrollToDateItem(this.selectedDate, "auto");
      }, 50);
    },

    // 获取联赛信息
    getLeagues() {
      if (this.category === 999) return;

      const params = {
        comps: [],
        date: this.selectedDate.ymd,
        match_name: "", // 赛事名称
        match_status: this.category, // 比赛状态, 0-所有(默认), 1-仅进行中的赛事,3-仅完场的赛事(赛果),赛程 666, 热门 777,赛事搜索888, 收藏999
        page: 1,
        size: 50,
        sport_id: this.sportId,
      };

      post({
        url: "/api/match/getCompMenuList",
        data: params,
      }).then((res) => {
        const result = res.data || {};
        if (result.status === 0) {
          this.leagues = result.data?.CompMenuList || [];
        }
      });
    },

    // 获取赛事列表
    getMatch() {
      console.log(this.selectedLeagues);
      if (this.category === 777 && this.sportId === 0) {
        this.sportId = 1;
      }
      const league_names = Object.keys(this.selectedLeagues).filter((v) => !!v);
      const params = {
        comps: league_names, // 联赛名称
        is_live: this.isLive, // 是否直播中 0 未直播 1 直播中
        date: this.selectedDate.ymd, // 是否直播中 0 未直播 1 直播中
        match_status: this.category, // 比赛状态,0-所有(默认),1-仅进行中的赛事,3-仅完场的赛事(赛果),赛程 666, 热门 777,赛事搜索888, 收藏999
        match_name: "",
        page: this.page,
        size: 10,
        sport_id: this.sportId, // 0全部 1足球 2篮球
        terminal: 3, // 0app 3 pc
      };
      this.resetUrlSearchQuery();

      this.loading = true;
      this.loaded = false;
      post({
        url: "/api/match/getMatchList",
        data: params,
      })
        .then((res) => {
          this.loading = false;
          this.loaded = true;
          this.showPopover = false;

          if (res.status === 200 && res.data.status === 0) {
            const result = res.data || {};

            this.matches = result.data?.matchList || [];
            //重构数组中的部分值显示方式
            let matches_obj = this.matches;
            this.matches.forEach(function (item, index) {
              if (item.sport_id == 2) {
                //初始化篮球已开始的时间
                matches_obj[index].time_played_str = "";
                if (item.raw_match_status >= 2 && item.raw_match_status <= 9) {
                  //如果篮球有进行中的赛事
                  let match_start_min = item.time_played;
                  //格式化以分钟为单位的比赛已开始时间
                  if (match_start_min > 0) {
                    if (match_start_min < 10) {
                      match_start_min = "0" + match_start_min;
                    }
                    let current_second = intval(new Date().getSeconds());
                    if (match_start_min < 10) {
                      current_second = "0" + current_second;
                    }
                    matches_obj[index].time_played_str =
                      match_start_min + ":" + current_second;
                  }
                }
              }
            });
            this.matches = matches_obj;

            this.totalCount = result.data?.count;
            // console.log(result.data, this.filterDates, this.selectedDate.ymd)
            this.dateOfCounts = result.data?.countOfDays || {};
            if (this.filterDates[this.selectedDate.ymd]) {
              this.filterDates[this.selectedDate.ymd].counts =
                result.data?.count;
            }
          }
        })
        .catch(() => {
          this.loaded = true;
          this.loading = false;
          this.showPopover = false;
        });
    },

    getUserFavoriteMatches() {
      const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
      if (!userInfo.token) return;

      post({
        url: "/api/match/countUserFavorite",
        data: {
          sport_id: this.sportId,
        },
      }).then((res) => {
        if (res.status === 200 && res.data?.status === 0) {
          this.favoriteMatches = res.data?.data?.quantity || 0;
        }
      });
    },

    /**
     * Toast效果
     * @param string message 提示消息内容
     * @param int second 消息显示的秒数，默认不提供为1.5秒
     * @param boolean status 状态：true为显示，false为隐藏，默认显示
     */
    setShowToast(message) {
      this.toastMessage = message;
      let second = arguments[1] ? arguments[1] : 1.5;
      this.showToast = arguments[2] ? arguments[2] : true;
      if (this.showToast === true) {
        clearTimeout(this.timerToast);
        this.timerToast = setTimeout(() => {
          this.showToast = false;
        }, second * 1000);
      }
    },
  },

  created() {
    this.initialPage();
    this.yestoday = dayCount(-1).ymd;
    this.today = dayCount(0).ymd;
    this.tomorroy = dayCount(1).ymd;
    this.league_colors = {
      A: {
        activeColor: "#02A8A2",
        activeBgColor:
          "#fff linear-gradient(0deg, rgba(2, 168, 162, 0.15), rgba(2, 168, 162, 0.15))",
      },
      B: {
        activeColor: "#6A2DFF",
        activeBgColor: "rgba(74, 0, 255, 0.1)",
      },
      C: {
        activeColor: "#265CF6",
        activeBgColor: "rgba(38, 92, 246, 0.15)",
      },
      D: {
        activeColor: "#5EAA00",
        activeBgColor: "#CDDDB9",
      },
      E: {
        activeColor: "#EB652B",
        activeBgColor: "rgba(255, 114, 55, 0.2)",
      },
      F: {
        activeColor: "#02A1F9",
        activeBgColor: "#A6DDE7",
      },
      G: {
        activeColor: "#3C9CFE",
        activeBgColor: "rgba(60, 156, 254, 0.2)",
      },
      H: {
        activeColor: "#02A8A2",
        activeBgColor: "rgba(69, 189, 153, 0.2)",
      },
      I: {
        activeColor: "#FFA600",
        activeBgColor: "rgba(255, 166, 0, 0.2)",
      },
      J: {
        activeColor: "#0031B1",
        activeBgColor: "rgba(0, 71, 255, 0.2)",
      },
      K: {
        activeColor: "#DC0049",
        activeBgColor: "rgba(255, 184, 208, 0.3)",
      },
      L: {
        activeColor: "#ED7200",
        activeBgColor: "rgba(255, 165, 0, 0.3)",
      },
      M: {
        activeColor: "#35B5FF",
        activeBgColor: "rgba(108, 202, 255, 0.3)",
      },
      N: {
        activeColor: "#00A769",
        activeBgColor: "rgba(0, 255, 162, 0.2)",
      },
      O: {
        activeColor: "#7A8A00",
        activeBgColor: "#E4EC9F",
      },
      P: {
        activeColor: "#BE0000",
        activeBgColor: "rgba(255, 0, 0, 0.2)",
      },
      Q: {
        activeColor: "#CC4343",
        activeBgColor: "rgba(255, 160, 159, 0.2)",
      },
      R: {
        activeColor: "#5E00D8",
        activeBgColor: "rgba(111, 0, 255, 0.2)",
      },
      S: {
        activeColor: "#02A1F9",
        activeBgColor: "rgba(79, 248, 255, 0.2)",
      },
      T: {
        activeColor: "#00A2A9",
        activeBgColor: "rgba(0, 224, 233, 0.3)",
      },
      U: {
        activeColor: "#8F00C3",
        activeBgColor: "rgba(205, 68, 255, 0.2)",
      },
      V: {
        activeColor: "#C90053",
        activeBgColor: "rgba(255, 0, 106, 0.2)",
      },
      W: {
        activeColor: "#FF7A00",
        activeBgColor: "rgba(255, 245, 0, 0.2)",
      },
      X: {
        activeColor: "#00A35E",
        activeBgColor: "rgba(0, 190, 109, 0.2)",
      },
      Y: {
        activeColor: "#CB0075",
        activeBgColor: "rgba(255, 0, 146, 0.15)",
      },
      Z: {
        activeColor: "#0082CD",
        activeBgColor: "rgba(131, 210, 255, 0.3)",
      },
    };
  },
};
</script>

<style lang="scss" scoped>
//toast效果
.toast_message {
  display: block;
  clear: both;
  width: auto;
  min-width: 2rem;
  height: 0.4rem;
  line-height: 0.2rem;
  overflow: hidden;
  background-color: #000;
  box-sizing: border-box;
  padding: 0.1rem;
  border-radius: 8px;
  font-size: 0.16rem;
  text-align: center;
  color: #fff;
  position: fixed;
  z-index: 100000;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
}
.schedule-page {
  width: 14rem;
  margin: 0 auto;
  box-sizing: border-box;
  margin-bottom: 0.4rem;
  padding-top: 0.8rem;

  .left-panel {
    width: 2.8rem;
    height: 100%;
    background-color: #2f3035;
    margin-right: 0.24rem;
    border-radius: 0.05rem 0.05rem 0px 0px;
  }

  .header-title {
    line-height: 0.36rem;
    font-weight: bold;
    color: #333;
  }

  .sport-category {
    width: 0.8rem;
    height: 0.4rem;
    overflow: hidden;
    border-radius: 0.4rem;
    margin-right: 0.3rem;
    cursor: pointer;
    font-size: 0.16rem;
    color: #999;
    position: relative;

    &:before {
      content: "";
      display: block;
      width: 100%;
      height: 100%;
      overflow: hidden;
      border-radius: 0.3rem;
      background-image: linear-gradient(to right, #e2e4e4, #d3d6da);
      position: absolute;
      z-index: -5;
      left: 0;
      top: 0;
    }

    &:after {
      content: "";
      display: block;
      width: calc(100% - 2px);
      height: calc(100% - 2px);
      overflow: hidden;
      border-radius: 0.3rem;
      background-color: #f4f5f8;
      position: absolute;
      z-index: -3;
      left: 1px;
      top: 1px;
    }

    /*鼠标滑过的时候，边框和文字变色*/
    &:hover {
      color: #02a8a2;
    }

    &:hover:before {
      background-image: linear-gradient(to right, #29f19c, #02a1f9);
    }

    /*选中的时候，没有边框，文字变色并加1px投影*/
    &.active {
      color: #fff;
      text-shadow: 0.5px 0.5px 0px #02a8a2;
      background-image: linear-gradient(to right, #29f19c, #02a1f9);
    }
  }

  .panel-content {
    padding: 0 0.08rem 0.1rem 0.14rem;
  }

  .panel-title {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 0.44rem;
    background: #02a8a2;
    font-weight: 400;
    font-size: 0.16rem;
    color: #fff;
    border-radius: 0.05rem 0.05rem 0px 0px;
  }

  .panel-tip {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 0.2rem;
    padding-bottom: 0.1rem;
    margin-right: 0.06rem;
    color: #fff;
    font-size: 0.16rem;

    .panel-tip-item {
      display: flex;
      align-items: center;

      &.msg {
        span {
          color: #02a8a2;
        }
      }

      img {
        padding-right: 0.08rem;
        width: 0.2rem;
        height: 0.2rem;
      }
    }
  }

  .type-panel {
    display: flex;
    flex-wrap: wrap;
  }

  .type-btn {
    width: 0.8rem;
    height: 0.36rem;
    margin: 5px 0px;
    border-radius: 0.02rem;
    font-size: 0.14rem;
    color: #fff;
    background: rgba(102, 102, 102, 0.2);
    cursor: pointer;
    text-align: center;
    line-height: 0.36rem;
    margin-right: 0.06rem;

    &.select {
      border: 0.01rem solid #02a8a2;
      color: #02a8a2;
    }
  }

  .show-more {
    width: 2.52rem;
    height: 0.24rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(102, 102, 102, 0.2);
    color: #fff;
    font-size: 0.14rem;
    cursor: pointer;

    img {
      width: 0.12rem;
      height: 0.06rem;
      margin-left: 0.04rem;
    }
  }

  .right-panel {
    margin-top: 0.2rem;
    width: 100%;
    background-color: #fafafa;

    .match-title {
      height: 0.57rem;
      background-color: #fff;
      border-bottom: 1px solid #02a8a2;
      display: flex;
      position: relative;

      .match-title-tab {
        width: 1.2rem;
        height: 0.57rem;
        font-size: 0.18rem;
        cursor: pointer;
        color: #666;
        position: relative;

        &.active {
          color: #02a8a2;
          background: linear-gradient(
            90deg,
            rgba(41, 241, 156, 0.2) 0%,
            rgba(2, 161, 249, 0.2) 112.41%
          );
        }
      }

      .favorite-badge {
        display: block;
        float: right;
        min-width: 0.1rem;
        height: 0.2rem;
        line-height: 0.2rem;
        overflow: hidden;
        background-color: #f64d5c;
        padding: 0px 0.05rem;
        border-radius: 0.2rem;
        font-size: 0.12rem;
        color: #fff;
        text-align: center;
        position: absolute;
        z-index: 2;
        top: 0.05rem;
        right: 0.12rem;
      }

      //调整选中时的箭头方向
      button.active .el-icon-caret-bottom:before {
        display: inline-block;
        transform: rotate(180deg);
        -ms-transform: rotate(180deg);
        /* IE 9 */
        -moz-transform: rotate(180deg);
        /* Firefox */
        -webkit-transform: rotate(180deg);
        /* Safari 和 Chrome */
        -o-transform: rotate(180deg);
        /* Opera */
      }
    }
  }

  .match-btn {
    width: 0.77rem;
    height: 0.4rem;
    position: absolute;
    right: 0.28rem;
    top: 50%;
    transform: translate3d(0, -50%, 0);
    padding: 0;
    font-size: 0.14rem;
    color: #666;
    background: #f4f5f8;
    border: none;

    &:hover,
    &.active {
      background: linear-gradient(
          90deg,
          rgba(41, 241, 156, 0.2) 0%,
          rgba(2, 161, 249, 0.2) 100%
        ),
        #ffffff;
      color: #02a8a2;
    }
  }

  .match-swiper {
    position: relative;
    background-color: #fafafa;
  }

  .match-swiper-line {
    margin-top: 0.23rem;
    width: 100%;
    height: 1px;
    background-image: url("./img/up-line.png");
    background-size: 100% 100%;
  }

  .swiper-match-date {
    //width: 13rem;
    width: 100%;
    overflow-x: scroll;
  }

  .swiper-slide {
    width: 14.28%;
  }

  .swiper-button {
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 100% auto;
    width: 24px;
    height: 96px;
    top: 50%;
    transform: translateY(-50%);
    margin: 0px;
    cursor: pointer;
  }

  .select-date-icon {
    margin: 0.11rem auto 0.13rem;
    width: 0.2rem;
    height: 0.24rem;
    background-image: url("./img/un-select.png");
    background-size: 100% 100%;
  }

  .date-item {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    color: #666666;
    font-size: 0.16rem;

    &:hover {
      .select-date-icon {
        background-image: url("./img/select-date.png");
      }

      .date-item-t {
        color: #333;
      }

      .up-line {
        display: block;
      }
    }

    &.select {
      .select-date-icon {
        background-image: url("./img/select-date.png");
        transform: scale(1.6);
        transition: transform 0.15s linear;
      }

      .date-item-t {
        color: #333;
        transform: scale(1.2);
      }
    }

    .date-item-t {
      color: #666;
      font-weight: 600;
      margin-bottom: 0.1rem;
      font-size: 0.14rem;
    }

    .date-item-b {
      color: #aaa;
      font-size: 0.12rem;
      font-weight: 600;
    }

    .up-line {
      display: none;
      top: 0;
      width: 0.88rem;
      height: 1px;
      background: url("./img/up-line-selected.png") no-repeat top center;
      background-size: auto 1px;
    }
  }

  .live-match {
    width: 100%;
    height: 100%;
    position: relative;

    .match-list-box {
      clear: both;
      width: 100%;
      overflow: hidden;
      margin-top: 0.12rem;
      box-shadow: 0rem 0rem 0.05rem rgba(0, 0, 0, 0.1);
      -webkit-box-shadow: 0rem 0rem 0.05rem rgba(0, 0, 0, 0.1);
      -moz-box-shadow: 0rem 0rem 0.05rem rgba(0, 0, 0, 0.1);
      -o-box-shadow: 0rem 0rem 0.05rem rgba(0, 0, 0, 0.1);
      -ms-box-shadow: 0rem 0rem 0.05rem rgba(0, 0, 0, 0.1);

      .match-title-starting {
        background-color: #f2fbfa;
      }

      .match-title-waiting {
        background-color: #f6f8ff;
      }

      .match-title-end {
        background-color: #fef4f7;
      }

      .match-title-exception {
        background-color: #fffcf5;
      }
    }

    .match-nav {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 0.2rem 0.2rem;
      font-size: 0.24rem;
      color: #000;

      .match-nav-btn {
        height: 0.26rem;
        line-height: 0.24rem;
        padding: 0 0.15rem;
        background: #ffffff;
        border: 1px solid #f0f0f0;
        border-radius: 0.13rem;
        font-size: 0.14rem;
        color: #999999;
        cursor: pointer;

        &.active {
          color: #02a8a2;
          border: 1px solid #02a8a2;
        }
      }

      div {
        margin-right: 10px;
      }
    }
  }

  .no-data {
    min-height: 5rem;

    img {
      width: 1.8rem;
      height: 1.8rem;
      position: absolute;
      top: 40%;
      left: 40%;
    }
  }

  .match-page {
    display: flex;
    justify-content: center;
    clear: both;
    width: 100%;
    overflow: hidden;
    padding: 15px 0px;
  }

  ::v-deep {
    .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #02a8a2;
    }

    .el-loading-spinner .path {
      stroke: #02a8a2;
    }
  }
}
</style>
